// <section-injection section-name="section-name"></section-injection>
class SectionInjection extends HTMLElement {
    get section() {
      return this.dataset.sectionName
    }

    get baseurl() {
      return this.dataset.baseurl || window.Shopify?.routes?.root || '/'
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (!!newValue && newValue !== oldValue) {
        this.fetch()
      }
    }

    connectedCallback() {
      this.fetch()
    }

    // this innerHTML sets and executed script tags in series, so that they are executed in order
    // each script tag is injected and awaited till it has finished loading
    async setInnerHTML(html) {
      this.innerHTML = html
      const scripts = this.querySelectorAll('script')
      for (const oldScriptEl of scripts) {
        const newScriptEl = document.createElement('script')
        const scriptLoaddefer = new Promise((resolve, reject) => {
          newScriptEl.onload = resolve
          Array.from(oldScriptEl.attributes).forEach((attr) => {
            newScriptEl.setAttribute(attr.name, attr.value)
          })

          const scriptText = document.createTextNode(oldScriptEl.innerHTML)
          newScriptEl.appendChild(scriptText)
          oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl)

          if (!oldScriptEl.hasAttribute('src')) {
            resolve()
          }
        })
        await scriptLoaddefer
      }
    }

    fetch() {
      fetch(`${this.baseurl}?section_id=${this.section}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status)
            throw error
          }

          return response.text()
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector(`#shopify-section-${this.section}`).innerHTML
          this.setInnerHTML(resultsMarkup)
        })
        .catch((error) => {
          throw error
        })
    }
  }

  window.customElements.define('section-injection', SectionInjection)
